@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4 ">

    <div class="leaveManagmentParent">
      <div class="leftLM" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
        <p class="headingleavemanagement">Leave Report</p>
      </div>
      <div class="rightLM">
        @if (isResetLeavePermission()) {
          <button type="button" class="btnResetLeave" data-toggle="modal" data-target="#conformModalCenter"
          >Reset Leaves</button>
        }
        <button type="button" class="btnLeaveReport" [routerLink]="'/show-leaves'"> Back </button>
        <!-- <button type="button" class="btnResetLeave">Reset Leaves</button> -->

      </div>
    </div>
    <!-- 2nd row -->
    <div class="parentFilter" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="leftsideFilter">
        <p class="headingFilter">Filters</p>
      </div>
      <div class="rightsideFilter">
        <div class="txtboxName"> <input type="text" placeholder="Search by Name" [(ngModel)]="searchName" /></div>
        <div class="btnApply"> <button type="button" (click)="searchDataFun()">Apply</button></div>
      </div>

    </div>

    <!-- 3rd row -->

    <div class="parentCurrentYear">

      <button type="button" (click)="showCurrentYearData()"
      [ngClass]="{'btnCurrentYear': isCurrentYearVisible , 'btnLastYear': isLastYearVisible}">Current Year</button>
      <button type="button" (click)="showLastYearData()"
      [ngClass]="{'btnCurrentYear': isLastYearVisible , 'btnLastYear': isCurrentYearVisible}">Last Year</button>


    </div>


    @if (isCurrentYearVisible) {
      <div class="tablewidth mt-0">
        <table class="bg-white table-container">
          <tr id="tableHead" class="tableHead">
            <th class="namefieldHead">Name</th>
            <th class="text-center">Total Leaves</th>
            <th class="text-center">Paid Leaves</th>
            <th class="text-center">Unpaid Leaves</th>
            <th class="text-center">Absents</th>
            <th class="text-center">Available Leaves</th>
          </tr>
          @for (f of pagedData; track f) {
            <tr class="tableData tableDataBorder">
              <td class="colorName" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                {{ f.name }}
              </td>
              <td class="text-center" [ngClass]="{ 'dark-backround-td': selectedMode === 'dark' }">
                {{ f.total_leaves | number:'1.2-2' }}
              </td>
              <td class="text-center" [ngClass]="{ 'dark-backround-td': selectedMode === 'dark' }">
                {{ f.paid_leaves | number:'1.2-2' }}
              </td>
              <td class="text-center" [ngClass]="{ 'dark-backround-td': selectedMode === 'dark' }">
                {{ f.unpaid_leaves | number:'1.2-2' }}
              </td>
              <td class="text-center" [ngClass]="{ 'dark-backround-td': selectedMode === 'dark' }">
                {{ f.absent | number:'1.2-2' }}
              </td>
              <td class="text-center" [ngClass]="{ 'dark-backround-td': selectedMode === 'dark' }">
                {{ (f.total_leaves - f.paid_leaves) | number:'1.2-2' }}
              </td>
            </tr>
          }
        </table>
        <mat-paginator [length]="apisecond.length" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]"
          (page)="onPageChange($event)">
        </mat-paginator>
      </div>
    }

    <!-- last year -->
    @if (isLastYearVisible) {
      <div class="tablewidth mt-0">
        <table class="bg-white table-container">
          <tr id="tableHead" class="tableHead">
            <th class="namefieldHead">Name</th>
            <th class="text-center">Total Leaves</th>
            <th class="text-center">Paid Leaves</th>
            <th class="text-center">Unpaid Leaves</th>
            <!-- <th class="text-center">Absents</th> -->
            <th class="text-center">Available Leaves</th>
          </tr>
          @for (f of pagedData; track f) {
            <tr class="tableData tableDataBorder">
              <td class="colorName" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">{{f.name}}</td>
              <td class="text-center" [ngClass]="{ 'dark-backround-td': selectedMode === 'dark' }">{{f.old_total_leaves}}
              </td>
              <td class="text-center" [ngClass]="{ 'dark-backround-td': selectedMode === 'dark' }">{{f.paid_leaves}}</td>
              <td class="text-center" [ngClass]="{ 'dark-backround-td': selectedMode === 'dark' }">{{f.unpaid_leaves}}
              </td>
              <!-- <td class="text-center" [ngClass]="{ 'dark-backround-td': selectedMode === 'dark' }">{{f.absent}}</td> -->
              <td class="text-center" [ngClass]="{ 'dark-backround-td': selectedMode === 'dark' }"> {{f.old_leaves}}</td>
            </tr>
          }
        </table>
        <mat-paginator [length]="apisecond.length" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]"
          (page)="onPageChange($event)">
        </mat-paginator>
      </div>
    }



    <!-- Modal -->
    <div class="modal fade" id="conformModalCenter" tabindex="-1" role="dialog" aria-labelledby="conformModalCenter"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <div class="modal-header modal-head-color" [ngClass]="{ 'dark-text-h5': selectedMode === 'dark' }">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h5 class="modal-title" id="exampleModalLongTitle">Do You Really Want to Reset !!!</h5>

          </div>
          <div class="modal-body text-center">
            <img src="../../../assets/images/Info_icon.svg" alt="Missing ">
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">No.</button>
            <button type="button" class="btn btn-primary" (click)="resetLeaves()">Yes, I Am Sure.</button>
          </div>
        </div>
      </div>
    </div>



  </div>
</main>